module.exports = __webpack_public_path__ + "frontend/images/pattern/pricing/gold@2.jpg?7976019a6ada236d6c6440c74122bf83";